import React from "react";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";
import { CDBCard, CDBContainer } from "cdbreact";
import { geDataFormat, getFormatOraInput } from "../../common/utils";
import { toast } from "react-toastify";
import { Table } from "react-bootstrap";
import ResetService from "./ResetService";

export default class Reset extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            filtro:{
                dataInizio:"",
                dataFine: "",
            },
            datiReset:[
            ]
        };

        this.resetService = new ResetService()

    }

    componentDidMount(){
        this.getReset()

    }

    onChangeDataInizio(event){
        this.setState((prevState)=>({filtro:{...prevState.filtro,dataInizio:event.target.value}}))
    }

    onChangeDataFine(event){
        this.setState((prevState)=>({filtro:{...prevState.filtro,dataFine:event.target.value}}))
    }


    getReset(){
        this.setState({loading:true})
        this.resetService.getResetList(
            this.state.filtro.dataInizio,
            this.state.filtro.dataFine,
            (result)=>{
                this.setState({datiReset:result})
                this.setState({loading:false})
            },
            (Error)=>{
                this.setState({loading:false})
                toast.error("Qualcosa e' andato storto, Riprova", {})

            }
        )
    }

    downloadReset(idReset,nomeFile){
        this.resetService.downloadFile(
            idReset,
            (result)=>{
                let file = result.toString().replace('"','')
                console.log("", file)
                const element = document.createElement('a')
                element.href = `data:text/plain;charset=utf-8;base64,${file}`
                element.download = `${nomeFile}`
                document.body.appendChild(element)
                element.click()
            },
            (error)=>{
                toast.error("Qualcosa e' andato storto, Riprova")
            }
            )
    }



    render(){
        return this.state.loading
        ? <LoadSpinner/>
        : (
            <div id="wrapper">
                <Menucustom/>
                <div className="container-fluid">
                    <br />
                    <br />
                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                        <h1 className="h1 mb-2 text-gray-800">
                        Reset
                        </h1>
                        </div>
                    <div>
                    <CDBContainer>
                        <CDBCard border>
                            <div className="container p-3">
                                <div className="row">
                                    <div className="col-5">
                                        <div className="col">Data Inizio: </div>
                                        <div className="col">
                                            <input
                                            value={this.state.filtro.dataInizio}
                                            type="date"
                                            className="form-control"
                                            onChange={this.onChangeDataInizio.bind(this)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5">
                                        <div className="col">Data Fine: </div>
                                        <div className="col">
                                        <input
                                        value={this.state.filtro.dataFine}
                                        type="date"
                                        className="form-control"
                                        onChange={this.onChangeDataFine.bind(this)}
                                        />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <br/>
                                        <button className="btn btn-warning" onClick={()=>this.getReset()}>Ricerca</button>
                                    </div>
                                </div>
                            </div>
                        </CDBCard>
                        </CDBContainer>
                    </div>
                    <div className="container d-flex justify-content-center pt-5">
                    <Table className="col-10 text-center" striped bordered hover>
                        <thead>
                            <tr>
                            <th>Data</th>
                            <th>Nome</th>
                            <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.datiReset.map((dato)=>{
                                return(
                                    <tr>
                                        <td>{geDataFormat(dato.dataInserimento)}</td>
                                        <td>{dato.nomeFile}</td>
                                        <td><i onClick={()=>this.downloadReset(dato.idReset, dato.nomeFile)} className="fas fa-download"></i></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        )
    }
}